const CONTENT_SCREENING_PROVIDER_NAMES = [
  "comprehend",
  "comprehend_medical"
];
const CONTENT_REDACTION_POLICY_NAMES = ["standard", "hipaa"];
export {
  CONTENT_REDACTION_POLICY_NAMES,
  CONTENT_SCREENING_PROVIDER_NAMES
};
//# sourceMappingURL=types.js.map
